/* SunFit Bundles - natiivi Kaching Bundles -klooni.
   Kaikki data tulee metaobjekteista Liquidin kautta; tämä hoitaa vain
   vuorovaikutuksen, A/B-jaon ja ostoskoriin ohjauksen. */
(function () {
  'use strict';

  var AB_KEY = 'sfb_ab_';

  function SunFitBundles(root) {
    var raw = root.querySelector('script[data-sfb-config]');
    if (!raw) return;
    this.root = root;
    try { this.cfg = JSON.parse(raw.textContent); } catch (e) { return; }
    this.form = null;
    this.init();
  }

  SunFitBundles.prototype.init = function () {
    var self = this;

    this.pickAbSet();

    this.bars = Array.prototype.slice.call(
      this.activeSet ? this.activeSet.querySelectorAll('.sfb__bar') : []
    );
    if (!this.bars.length) return;

    this.bars.forEach(function (bar) {
      bar.addEventListener('click', function (e) {
        if (e.target.closest('.sfb__dropdown')) return;
        if (e.target.closest('.sfb__upsell')) return;
        self.select(bar);
      });
      bar.addEventListener('keydown', function (e) {
        if (e.target.closest('.sfb__dropdown')) return;
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); self.select(bar); }
      });
    });

    delegate(this.root, '.sfb__dd-button', 'click', function (btn, e) {
      e.preventDefault(); e.stopPropagation();
      var dd = btn.closest('.sfb__dropdown');
      var wasOpen = dd.classList.contains('is-open');
      self.closeDropdowns();
      if (!wasOpen) {
        dd.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });

    delegate(this.root, '.sfb__dd-option', 'click', function (opt, e) {
      e.preventDefault(); e.stopPropagation();
      self.choose(opt);
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('.sfb__dropdown')) self.closeDropdowns();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') self.closeDropdowns();
    });

    this.form = document.querySelector('product-form form[action*="/cart/add"]')
      || document.querySelector('form[action*="/cart/add"]');

    /* Vain YKSI widget saa kaapata lomakkeen. Jos sivulla on kaksi widgettiä
       (sovellusversio + vanha sektioversio), molemmat asettaisivat
       window.location.href, ja jälkimmäinen voittaisi - sen osoitteessa ei ole
       alennuskoodia, jolloin asiakas päätyy kassalle täyteen hintaan. */
    if (this.form && this.form.dataset.sfbOwner) this.form = null;

    if (this.form) {
      this.form.dataset.sfbOwner = this.cfg.deal || '1';
      this.form.addEventListener('submit', function (e) {
        var bar = self.selected();
        if (!bar) return;
        e.preventDefault();
        e.stopPropagation();
        self.goToCart(bar);
      }, true);
    }

    // Peilaa teeman oma varianttivalinta ensimmäiseen riviin
    document.addEventListener('change', function (e) {
      if (!e.target.closest) return;
      if (!e.target.closest('variant-selects, variant-radios, .product-form__input')) return;
      window.setTimeout(function () { self.syncFromTheme(); }, 60);
    });

    var pre = this.bars.filter(function (b) {
      return b.classList.contains('sfb__bar--preselected');
    })[0];
    this.select(pre || this.bars[0]);
  };

  /* --- A/B --- */
  SunFitBundles.prototype.pickAbSet = function () {
    var sets = this.root.querySelectorAll('.sfb__bars');
    if (!this.cfg.ab || sets.length < 2) {
      this.activeSet = sets[0] || null;
      if (this.activeSet) this.activeSet.hidden = false;
      this.abLetter = 'A';
      return;
    }
    var key = AB_KEY + this.cfg.deal + (this.cfg.abTest ? '_' + this.cfg.abTest : '');
    var letter = null;
    try { letter = window.localStorage.getItem(key); } catch (e) {}
    if (letter !== 'A' && letter !== 'B') {
      letter = Math.random() < 0.5 ? 'A' : 'B';
      try { window.localStorage.setItem(key, letter); } catch (e) {}
    }
    this.abLetter = letter;
    this.countView(letter);
    Array.prototype.forEach.call(sets, function (s) {
      s.hidden = s.dataset.sfbSet !== letter;
    });
    this.activeSet = this.root.querySelector('.sfb__bars[data-sfb-set="' + letter + '"]')
      || sets[0];
  };

  /* Laskee kavijat versiota kohti. Yksi ping per kavija per istunto, ja mukana
     menee vain tarjouksen tunnus + kirjain A/B - ei mitaan henkilotietoa, ei
     evasteita. Osoite tulee tarjouksen stats_url-kentasta; jos se on tyhja,
     mitaan ei laheteta. */
  SunFitBundles.prototype.countView = function (letter) {
    var url = (this.cfg.stats || '').trim();
    if (!url) return;
    var key = 'sfb_seen_' + this.cfg.deal + '_' + letter;
    try { if (window.sessionStorage.getItem(key)) return; } catch (e) {}
    try { window.sessionStorage.setItem(key, '1'); } catch (e) {}

    var q = url + (url.indexOf('?') === -1 ? '?' : '&') +
      'deal=' + encodeURIComponent(this.cfg.deal) + '&v=' + encodeURIComponent(letter);
    try {
      if (navigator.sendBeacon) { navigator.sendBeacon(q); return; }
    } catch (e) {}
    try {
      fetch(q, { method: 'GET', mode: 'no-cors', credentials: 'omit', keepalive: true });
    } catch (e) {}
  };

  function delegate(root, selector, type, handler) {
    root.addEventListener(type, function (e) {
      var el = e.target.closest ? e.target.closest(selector) : null;
      if (el && root.contains(el)) handler(el, e);
    });
  }

  SunFitBundles.prototype.selected = function () {
    return this.bars.filter(function (b) { return b.classList.contains('is-selected'); })[0] || null;
  };

  SunFitBundles.prototype.select = function (bar) {
    if (!bar) return;
    this.bars.forEach(function (b) {
      var on = b === bar;
      b.classList.toggle('is-selected', on);
      var input = b.querySelector('input[type="radio"]');
      if (input) input.checked = on;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    this.closeDropdowns();
    this.hideDynamicCheckout();
  };

  /* Dynaaminen kassapainike ohittaisi nipun kokonaan, joten se piilotetaan
     kun nippu on valittuna - samoin kuin Kaching tekee. */
  SunFitBundles.prototype.hideDynamicCheckout = function () {
    if (!this.form) return;
    var dyn = this.form.querySelector('.shopify-payment-button');
    if (dyn) dyn.style.display = this.selected() ? 'none' : '';
  };

  SunFitBundles.prototype.closeDropdowns = function () {
    Array.prototype.forEach.call(this.root.querySelectorAll('.sfb__dropdown.is-open'), function (d) {
      d.classList.remove('is-open');
      var b = d.querySelector('.sfb__dd-button');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  };

  SunFitBundles.prototype.choose = function (opt) {
    var dd = opt.closest('.sfb__dropdown');
    var btn = dd.querySelector('.sfb__dd-button');
    var img = opt.dataset.sfbImage || '';

    dd.dataset.sfbVariantId = opt.dataset.sfbVariantId;
    btn.querySelector('.sfb__dd-value').textContent = opt.dataset.sfbLabel;

    var sw = btn.querySelector('.sfb__swatch');
    if (sw && img) sw.style.backgroundImage = 'url("' + img + '")';

    var rowImg = dd.closest('.sfb__variant').querySelector('.sfb__variant-image');
    if (rowImg && img) rowImg.src = img;

    Array.prototype.forEach.call(dd.querySelectorAll('.sfb__dd-option'), function (o) {
      o.setAttribute('aria-selected', o === opt ? 'true' : 'false');
    });
    this.closeDropdowns();
  };

  SunFitBundles.prototype.syncFromTheme = function () {
    var bar = this.selected();
    if (!bar) return;
    var native = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!native || !native.value) return;
    var dd = bar.querySelector('.sfb__dropdown');
    if (!dd) return;
    var opt = dd.querySelector('.sfb__dd-option[data-sfb-variant-id="' + native.value + '"]');
    if (opt) this.choose(opt);
  };

  SunFitBundles.prototype.goToCart = function (bar) {
    var ids = Array.prototype.slice.call(bar.querySelectorAll('.sfb__dropdown'))
      .map(function (dd) { return dd.dataset.sfbVariantId; })
      .filter(Boolean);

    if (!ids.length) {
      var native = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var qty = parseInt(bar.dataset.sfbQuantity, 10) || 1;
      if (!native || !native.value) return;
      for (var i = 0; i < qty; i++) ids.push(native.value);
    }

    var parts = ids.map(function (id) { return id + ':1'; });

    var gift = bar.dataset.sfbGiftVariant;
    if (gift) parts.push(gift + ':1');

    /* Merforsaljning: bara med om kunden bockat i rutan. */
    var upWrap = bar.querySelector('.sfb__upsell[data-sfb-upsell-variant]');
    if (upWrap) {
      var upBox = upWrap.querySelector('.sfb__upsell-box');
      if (upBox && upBox.checked) parts.push(upWrap.dataset.sfbUpsellVariant + ':1');
    }

    var url = this.cfg.routes.cart + '/' + parts.join(',');
    var qs = [];
    var code = (bar.dataset.sfbDiscount || '').trim();
    if (code) {
      qs.push('discount=' + encodeURIComponent(code));
    } else if (bar.dataset.sfbNeedsDiscount === '1') {
      /* Nippuhinta on yksikköhintoja halvempi mutta koodi puuttuu - asiakas
         maksaisi täyden hinnan. Kerrotaan se konsolissa selvästi. */
      if (window.console) {
        console.error('SunFit Bundles: palkilta "' + (bar.dataset.sfbBar || '?') +
          '" puuttuu alennuskoodi. Julkaise tarjous sovelluksessa uudelleen.');
      }
    }
    /* Väli on koodattava, muuten parametri katkeaa eikä A/B-merkintä tallennu. */
    if (this.cfg.ab) qs.push('attributes[SunFit%20A/B]=' + encodeURIComponent(this.abLetter));
    if (this.cfg.ab && this.cfg.abTest) qs.push('attributes[SunFit%20A/B-test]=' + encodeURIComponent(this.cfg.abTest));
    if (qs.length) url += '?' + qs.join('&');

    window.location.href = url;
  };

  /* Siirtää widgetin ostoskoripainikkeen yläpuolelle, samaan paikkaan
     jossa Kaching istuu. Sektio itse voi olla missä tahansa mallissa. */
  function relocate() {
    /* Metaobjektiversio (SunFit Bundles -sovellus) voittaa aina. Jos se on
       sivulla, vanha sektioversio POISTETAAN DOMista kokonaan - pelkkä
       piilottaminen ei riitä, koska piilotettu widget käynnistyisi silti ja
       ohjaisi kassalle ilman alennuskoodia. Tämä ajetaan ennen host-tarkistusta,
       jotta siivous tapahtuu myös malleissa joissa nappia ei löydy. */
    if (document.querySelector('.sfb:not([data-sfb-move])')) {
      Array.prototype.forEach.call(document.querySelectorAll('.sfb[data-sfb-move]'), function (sec) {
        var w = sec.closest('.shopify-section');
        if (sec.parentNode) sec.parentNode.removeChild(sec);
        if (w) w.style.display = 'none';
      });
      return;
    }

    var host = document.querySelector('product-form form[action*="/cart/add"] .product-form__buttons')
      || document.querySelector('form[action*="/cart/add"] .product-form__buttons');
    if (!host) return;
    Array.prototype.forEach.call(document.querySelectorAll('.sfb[data-sfb-move]'), function (el) {
      if (el.dataset.sfbMoved) return;
      var wrap = el.closest('.shopify-section');
      host.parentNode.insertBefore(el, host);
      el.dataset.sfbMoved = '1';
      if (wrap) wrap.style.display = 'none';
    });
  }

  function boot() {
    relocate();
    Array.prototype.forEach.call(document.querySelectorAll('.sfb'), function (el) {
      if (el.dataset.sfbReady) return;
      el.dataset.sfbReady = '1';
      new SunFitBundles(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
